import { render, staticRenderFns } from "./StudentMarksByQuarter.vue?vue&type=template&id=6cda55dc&"
import script from "./StudentMarksByQuarter.vue?vue&type=script&lang=js&"
export * from "./StudentMarksByQuarter.vue?vue&type=script&lang=js&"
import style0 from "./StudentMarksByQuarter.vue?vue&type=style&index=0&id=6cda55dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports